import React, { useMemo } from "react";
import "./screen.scss";
import ScreenDom from "./ScreenDom";

const Screen = ({ activeSwitch, setEffectMode, effectMode }) => {
  const returnMaterial = useMemo(() => {
    if (activeSwitch === 0) {
      return (
        <meshPhongMaterial
          attach="material"
          color="lightgray"
          emissive="#333333"
          emissiveIntensity={0.1}
          shininess={50}
        />
      );
    } else if (activeSwitch === 1) {
      return (
        <meshPhongMaterial
          attach="material"
          color="lightgray"
          emissive="#222222"
          emissiveIntensity={0.08}
          shininess={60}
        />
      );
    } else {
      return (
        <meshPhongMaterial color="white" attach="material" shininess={40} />
      );
    }
  }, [activeSwitch]);
  return (
    <group>
      <ScreenDom setEffectMode={setEffectMode} effectMode={effectMode} />
      <mesh recieveShadow position={[0, 2.75, 1.75]}>
        <boxBufferGeometry attach="geometry" args={[8, 3.25]} />
        {returnMaterial}
      </mesh>
    </group>
  );
};

export default Screen;
